import {
  AccountRouteEnum,
  DepositRouteEnum,
  PromotionRouteEnum,
  RoutesEnum,
  WithdrawRouteEnum,
  DepositMethod,
  WithdrawMethod,
  GameCategoryEnum,
} from '~/enums'
import type { FooterMenu, HeaderTabItem, MenuItem } from '~/types/app'
import type { DepositMethodMenu } from '~/types/deposit'

export const HEADER_MENUS: HeaderTabItem[] = [
  {
    title: 'Thể thao',
    key: GameCategoryEnum.Sports,
    to: RoutesEnum.Sports,
    icon: 'icon-sport',
  },
  {
    title: 'Live Casino',
    key: GameCategoryEnum.Casino,
    to: RoutesEnum.LiveCasino,
    icon: 'icon-casino',
  },
  {
    title: 'Slots',
    key: GameCategoryEnum.Slots,
    to: RoutesEnum.Slots,
    icon: 'icon-slots',
  },
  {
    title: 'Lô đề',
    key: GameCategoryEnum.Lode,
    to: RoutesEnum.Lode,
    icon: 'icon-lottery',
  },
  {
    title: 'Trò chơi',
    key: GameCategoryEnum.LobbyGame,
    to: RoutesEnum.LobbyGame,
    icon: 'icon-table-games',
  },
]

export const PROFILE_MENUS: MenuItem[] = [
  {
    key: 'information',
    title: 'Thông tin cá nhân',
    image: '/images/account/icon-information.svg',
    imageActive: '/images/account/icon-information-active.svg',
    to: AccountRouteEnum.Account,
  },
  {
    key: 'user-bank',
    title: 'Quản lý ngân hàng',
    image: '/images/account/icon-user-bank.svg',
    imageActive: '/images/account/icon-user-bank-active.svg',
    to: AccountRouteEnum.UserBank,
  },
  {
    key: 'transaction',
    title: 'Lịch sử giao dịch',
    image: '/images/account/icon-transaction.svg',
    imageActive: '/images/account/icon-transaction-active.svg',
    to: AccountRouteEnum.Transaction,
  },
  {
    key: 'betting',
    title: 'Lịch sử cá cược',
    image: '/images/account/icon-betting.svg',
    imageActive: '/images/account/icon-betting-active.svg',
    to: AccountRouteEnum.BetHistory,
  },
  {
    key: 'deposit',
    title: 'Rút tiền',
    image: '/images/account/icon-deposit.svg',
    imageActive: '/images/account/icon-deposit-active.svg',
    to: WithdrawRouteEnum.WithdrawBank,
  },
]

export const PROFILE_MENUS_MOBILE: MenuItem[] = [
  {
    key: 'information',
    title: 'Thông tin cá nhân',
    image: '/images/account/icon-information.svg',
    imageActive: '/images/account/icon-information-active.svg',
    to: AccountRouteEnum.AccountInformation,
  },
  {
    key: 'user-bank',
    title: 'Quản lý ngân hàng',
    image: '/images/account/icon-user-bank.svg',
    imageActive: '/images/account/icon-user-bank-active.svg',
    to: AccountRouteEnum.UserBank,
  },
  {
    key: 'transaction',
    title: 'Lịch sử giao dịch',
    image: '/images/account/icon-transaction.svg',
    imageActive: '/images/account/icon-transaction-active.svg',
    to: AccountRouteEnum.Transaction,
  },
  {
    key: 'betting',
    title: 'Lịch sử cá cược',
    image: '/images/account/icon-betting.svg',
    imageActive: '/images/account/icon-betting-active.svg',
    to: AccountRouteEnum.BetHistory,
  },
  {
    key: 'promotion',
    title: 'Khuyến mãi của bạn',
    image: '/images/account/icon-promotion.svg',
    imageActive: '/images/account/icon-promotion-active.svg',
    to: AccountRouteEnum.MyPromotion,
  },
]

export const FOOTER_MENUS = (brandName: string): FooterMenu[] => [
  {
    title: `Thông tin ${brandName}`,
    menus: [
      {
        title: 'Về chúng tôi',
        to: RoutesEnum.About,
      },
      {
        title: 'Khuyến mãi',
        to: PromotionRouteEnum.Promotion,
      },
      {
        title: 'Chính sách bảo mật',
        to: RoutesEnum.PrivacyPolicy,
      },
      {
        title: 'Liên hệ',
        to: RoutesEnum.ContactUs,
      },
      {
        title: 'Điều khoản điều kiện',
        to: RoutesEnum.TermsAndConditions,
      },
      {
        title: 'Hướng dẫn đăng ký',
        to: RoutesEnum.InstructRegister,
      },
      {
        title: 'Cược hợp pháp',
        to: RoutesEnum.LegalBetting,
      },
    ],
  },
  {
    title: 'Danh mục sản phẩm',
    menus: [
      {
        title: 'Thể thao',
        to: RoutesEnum.Sports,
      },
      {
        title: 'Live Casino',
        to: RoutesEnum.LiveCasino,
      },
      {
        title: 'Trò chơi',
        to: RoutesEnum.LobbyGame,
      },
    ],
  },
  {
    title: 'Tin tức',
    menus: [
      {
        title: 'Nhận định bóng đá',
        to: RoutesEnum.FootballNews,
      },
      {
        title: 'Tip bóng đá',
        to: RoutesEnum.TipFootball,
      },
      {
        title: 'Lô đề Online',
        to: RoutesEnum.LodeOnline,
      },
    ],
  },
]

export const DEPOSIT_METHOD_MOBILE_MENUS: DepositMethodMenu[] = [
  {
    method: DepositMethod.QRPay,
    title: 'Nạp QRPay',
    titleMB: 'QRPay',
    to: DepositRouteEnum.QRPay,
    image: '/images/account/icon-menu-qr-pay.svg',
  },
  {
    method: DepositMethod.PhoneCard,
    title: 'Nạp Thẻ Cào',
    titleMB: 'Thẻ Cào',
    to: DepositRouteEnum.PhoneCard,
    image: '/images/account/icon-menu-phone-card.svg',
  },
  {
    method: DepositMethod.Ewallet,
    title: 'Nạp Ví Điện Tử',
    titleMB: 'Ví Điện Tử',
    to: DepositRouteEnum.Ewallet,
    image: '/images/account/icon-menu-ewallet.svg',
  },
  {
    method: DepositMethod.Crypto,
    title: 'Nạp Crypto',
    titleMB: 'Crypto',
    to: DepositRouteEnum.Crypto,
    image: '/images/account/icon-menu-crypto.svg',
  },
]

export const WITHDRAW_METHOD_MOBILE_MENUS: DepositMethodMenu[] = [
  {
    method: WithdrawMethod.Banking,
    title: 'Ngân hàng',
    to: WithdrawRouteEnum.WithdrawBank,
    image: '/images/account/icon-menu-banking.svg',
  },
  {
    method: WithdrawMethod.PhoneCard,
    title: 'Thẻ cào',
    to: WithdrawRouteEnum.WithdrawPhoneCard,
    image: '/images/account/icon-menu-phone-card.svg',
  },
  {
    method: WithdrawMethod.Crypto,
    title: 'Crypto',
    to: WithdrawRouteEnum.WithdrawCrypto,
    image: '/images/account/icon-menu-crypto.svg',
  },
]
